import {connect} from 'react-redux'
import SnackBar from "../../Components/SnackBar/SnackBar";
import _ from "lodash";

const mapStateToProps = (store) => {
    return {
        orders: store.ordersReducer.deliveryOrders,
        messengers: store.usersReducer.users.filter(user => _.get(user, "profiles.messenger.isCurrentlyOnShift")),
        notifications: store.businessReducer.business.notifications
    };
};

const SnackbarContainer = connect(mapStateToProps)(SnackBar);

export default SnackbarContainer;